import { render, staticRenderFns } from "./AdminContract2024List.vue?vue&type=template&id=2a28d74a&scoped=true"
import script from "./AdminContract2024List.vue?vue&type=script&lang=js"
export * from "./AdminContract2024List.vue?vue&type=script&lang=js"
import style0 from "./AdminContract2024List.vue?vue&type=style&index=0&id=2a28d74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28d74a",
  null
  
)

export default component.exports